<template>
  <nav>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      :expand-on-hover="mini"
      :width="300"
      :mini-variant-width="84"
      color="blue-grey lighten-5"
      app
      class="berry-drawer menu-elevado"
      mobile-breakpoint="1280"
    >
      <div class="px-4 py-3 d-flex align-center berry-brand">
        <v-avatar size="36" class="mr-3">
          <v-img src="/favicon.ico" alt="logo"></v-img>
        </v-avatar>
        <div v-if="!mini" class="font-weight-medium"></div>
      </div>
      <v-divider></v-divider>
      <v-list dense nav class="berry-list">
        <v-list-item
          exact
          class="berry-item"
          active-class="berry-active"
          router
          to="/"
        >
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-group
          :value="true"
          v-if="renderlist(cadastro)"
          no-action
          class="berry-group"
        >
          <template v-slot:activator>
            <div v-if="!mini" class="berry-section px-4 mt-2 mb-1">
              CADASTRO
            </div>
          </template>
          <v-list-item
            v-for="item in cadastro"
            :key="item.title"
            router
            :to="item.route"
            v-if="isAllowed(item.idModulo)"
            @click="item.method"
            exact
            class="berry-item"
            active-class="berry-active"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="isAllowed(moduloCompras)"
          :disabled="isAllowed(moduloCompras) == false"
          v-if="renderlist(compras)"
          no-action
        >
          <template v-slot:activator>
            <div v-if="!mini" class="berry-section px-4 mt-2 mb-1">COMPRAS</div>
          </template>
          <v-list-item
            v-for="item in compras"
            :key="item.title"
            router
            :to="item.route"
            v-if="isAllowed(item.idModulo)"
            @click="item.method"
            exact
            class="berry-item"
            active-class="berry-active"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="true" v-if="renderlist(almoxarifado)" no-action>
          <template v-slot:activator>
            <div v-if="!mini" class="berry-section px-4 mt-2 mb-1">
              ALMOXARIFADO
            </div>
          </template>
          <v-list-item
            v-for="item in almoxarifado"
            :key="item.title"
            router
            :to="item.route"
            v-if="isAllowed(item.idModulo)"
            @click="item.method"
            exact
            class="berry-item"
            active-class="berry-active"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="renderlist(manutencao)" v-if="renderlist(manutencao)" no-action>
          <template v-slot:activator>
            <div v-if="!mini" class="berry-section px-4 mt-2 mb-1">
              MANUTENÇÃO
            </div>
          </template>
          <v-list-item
            v-for="item in manutencao"
            :key="item.title"
            router
            :to="item.route"
            v-if="isAllowed(item.idModulo)"
            @click="item.method"
            exact
            class="berry-item"
            active-class="berry-active"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- Rodapé / perfil -->
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="px-3 py-3 d-flex align-center berry-user">
          <v-list-item-avatar v-if="userAvatar">
            <v-img :src="userAvatar"></v-img>
          </v-list-item-avatar>
          <avatar v-else :fullname="username"></avatar>

          <div v-if="!mini" class="ml-3">
            <div class="text-body-2 font-weight-medium">{{ username }}</div>
            <div class="text-body-2 font-weight-medium">{{ userperfil }}</div>
            <v-btn small text class="pa-0 text--primary" @click="sair"
              >Sair</v-btn
            >
          </div>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import Avatar from "vue-avatar-component";
import {
  getUserName,
  getUserMail,
  getUserPerfil,
  getUserAvatar,
  getUserRoles,
} from "../../services/loginService";
import { mapState, mapActions } from "vuex";
import { logout } from "../../services/loginService";

export default {
  data() {
    return {
      username: "U",
      userMail: null,
      userperfil: null,
      moduloCompras: 9,
      userAvatar: null,
      acesso: [
        { icon: "group", title: "Usuário", route: "/usuario", idModulo: 1 },
        { icon: "badge", title: "Cargo", route: "/cargo", idModulo: 1 },
        {
          icon: "assignment_ind",
          title: "Perfil",
          route: "/perfil",
          idModulo: 1,
        },
        { icon: "lock", title: "Permissão", route: "/permissao", idModulo: 1 },
      ],
      almoxarifado: [
        {
          icon: "request_page",
          title: "Baixar Requisição",
          route: "/baixaRequisicao",
          method: () => this.feeRequest(),
          idModulo: 12,
        },
        {
          icon: "group",
          title: "Protocolo Entrega",
          route: "/protocoloEntrega",
          idModulo: 19,
        },
        {
          icon: "group",
          title: "Entrada de Nota",
          route: "/entradaNF",
          idModulo: 20,
        },
      ],
      produtoServico: [
        {
          icon: "category",
          title: "Produtos e Servços",
          route: "/produto&servico",
          idModulo: 6,
        },
        { icon: "group_work", title: "Grupo", route: "/grupoProduto", idModulo: 6 },
        {
          icon: "auto_awesome_motion",
          title: "Subgrupo",
          route: "/subGrupoProduto",
          idModulo: 6,
        },
        {
          icon: "branding_watermark",
          title: "Marca",
          route: "/marca",
          idModulo: 6,
        },
        {
          icon: "app_registration",
          title: "Unidade de Medida",
          route: "/unidadeMedida",
          idModulo: 6,
        },
      ],
      cadastro: [
        {
          icon: "manage_accounts",
          title: "Acesso",
          route: "/acessos",
          idModulo: 1,
          method: () => this.profile(),
        },
        {
          icon: "business",
          title: "Empresa",
          route: "/empresa",
          idModulo: 2,
          method: () => this.profile(),
        },
        {
          icon: "construction",
          title: "Equipamento",
          route: "/equipamentos",
          idModulo: 3,
          method: () => this.feeRequest(),
        },
        {
          icon: "add_business",
          title: "Fornecedores",
          route: "/fornecedor",
          idModulo: 4,
          method: () => this.profile(),
        },
        {
          icon: "remove_circle_outline",
          title: "Limites",
          route: "/limite",
          idModulo: 5,
          method: () => this.profile(),
        },
        {
          icon: "category",
          title: "Produtos e Serviços",
          route: "/produtoseservicos",
          idModulo: 6,
          method: () => this.feeRequest(),
        },
        {
          icon: "room_preferences",
          title: "Locais",
          route: "/local",
          idModulo: 7,
          method: () => this.profile(),
        },
        {
          icon: "room_preferences",
          title: "Mecânicos",
          route: "/mecanico",
          idModulo: 13,
          method: () => this.profile(),
        },
        {
          icon: "room_preferences",
          title: "Plano Manutenção",
          route: "/planoManutencao",
          idModulo: 14,
          method: () => this.profile(),
        },
        {
          icon: "room_preferences",
          title: "Localização",
          route: "/localizacao",
          idModulo: 16,
          method: () => this.profile(),
        },
      ],

      equipamento: [
        {
          icon: "construction",
          title: "Equipamento",
          route: "/equipamento",
          idModulo: 3,
        },
        {
          icon: "app_registration",
          title: "Implemento",
          route: "/implemento",
          idModulo: 3,
        },
        {
          icon: "people_outline",
          title: "Familia",
          route: "/familia",
          idModulo: 3,
        },
        {
          icon: "people_outline",
          title: "Marca Equipamento",
          route: "/marcaEquipamento",
          idModulo: 3,
        },
        {
          icon: "people_outline",
          title: "Modelos",
          route: "/modelo",
          idModulo: 3,
        },
        {
          icon: "people_outline",
          title: "Grupos",
          route: "/grupoEquipamento",
          idModulo: 3,
        },
      ],

      manutencao: [
        {
          icon: "handyman",
          title: "Chamado de Manutenção",
          route: "/chamadoManutencao",
          idModulo: 18,
        },
        {
          icon: "task",
          title: "Ordem de Serviço",
          route: "/ordemServico",
          idModulo: 17,
        },
      ],
      compras: [
        {
          title: "Requisição",
          route: "/requisicao",
          icon: "mdi-note-text",
          idModulo: 8,
        },
        {
          title: "Requisição Serviço",
          route: "/requisicaoServico",
          icon: "mdi-file-document-edit",
          idModulo: 8,
        },
        {
          title: "Solicitação",
          route: "/solicitacao",
          icon: "mdi-clipboard-text",
          idModulo: 9,
        },
        {
          title: "Mapa Cotação",
          route: "/mapaCotacao",
          icon: "mdi-file-chart",
          idModulo: 10,
        },
        {
          title: "Pedido Compra",
          route: "/pedido",
          icon: "mdi-file-cabinet",
          idModulo: 11,
        },
        {
          title: "Pedido Compra Local",
          route: "/pedidoAvulso",
          icon: "mdi-file-cabinet",
          idModulo: 21,
        },
      ],
      model: 1,
    };
  },
  computed: {
    ...mapState("sistema", ["drawer"]),
  },
  created() {
    var nome = getUserName();
    var mail = getUserMail();
    var perfil = getUserPerfil();
    var avatar = getUserAvatar();
    var roles = getUserRoles();
    if (nome) {
      this.username = nome;
    }
    if (mail) {
      this.userMail = mail;
    }
    if (perfil) {
      this.userperfil = perfil;
    }
    if (avatar) {
      this.userAvatar = avatar;
    }
    if (roles) {
      this.regras = roles;
    }
  },
  methods: {
    ...mapActions("sistema", ["atualizarDrawer"]),
    isAllowed(id) {
      return (
        this.regras.filter((r) => {
          return r.idModulo == id;
        }).length > 0
      );
    },
    renderlist(lista) {
      for (const item of lista) {
        if (this.isAllowed(item.idModulo)) {
          return true;
        }
      }
      return false;
    },
    sair() {
      logout();
      this.$router.push("/login");
    },
  },
  components: { Avatar },
};
</script>

<style scoped>
/* --- Look & feel inspirado no Berry --- */
.berry-drawer {
  border-right: 1px solid #e9ecef;
}

.berry-brand {
  min-height: 56px;
}

/* Título da seção */
.berry-section {
  font-size: 11px;
  letter-spacing: 0.08em;
  color: #90a4ae;
  font-weight: 700;
}

/* Ítens */
.berry-item {
  margin: 4px 8px;
  border-radius: 12px;
  height: 40px;
  padding: 0 10px;
}
.berry-item .v-list-item__icon {
  min-width: 32px;
}
.berry-item-disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Sub-itens (dentro do grupo) */
.berry-subitem {
  margin: 2px 12px 2px 32px;
  border-radius: 10px;
  height: 36px;
  padding: 0 10px;
}

/* Estado ativo tipo "pill" */
.berry-active {
  background: #e3f2fd !important; /* leve azul */
  color: #1976d2 !important; /* primary */
  box-shadow: 0 1px 0 rgba(25, 118, 210, 0.1),
    inset 0 0 0 1px rgba(25, 118, 210, 0.08);
}
.berry-active .v-icon {
  color: #1976d2 !important;
}

/* Chevron */
.chev {
  transition: transform 0.2s ease;
}
.chev.rot {
  transform: rotate(180deg);
}

/* Rodapé perfil */
.berry-user .v-list-item__avatar,
.berry-user .v-avatar {
  width: 36px;
  height: 36px;
}

/* Drawer elevado (já tinha no seu) */
.menu-elevado {
  background: #f8f9fa;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);
}

/* Ajustes responsivos */
@media (max-width: 1280px) {
  .berry-drawer {
    /* Em telas menores, sugerimos exibir expandido (sem mini) */
  }
}
</style>
